export default "__VITE_ASSET__DkAjJv4u__"